
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAutonomous as ObiAutonomousElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-autonomous.js';
 
 
 

 
 export const ObiAutonomous = createComponent({
   react: React,
   tagName: 'obi-autonomous',
   elementClass: ObiAutonomousElement,
   events: {
     
   }
  });
 
 